import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton } from '@mui/material';

// ToDo: WW-7459 Move to shared shadow folder
import { useSelectedPositionState } from '../../../../../../erp/components/tab-panels/positions/components/hooks/use-selected-position';
import { EditTableEntry, IdArray } from '../edit-table/types';

interface ClonePositionButtonProps {
  onClonePosition: (copyPositions: IdArray) => void;
  disabled: boolean;
  positions: EditTableEntry[];
}

export const ClonePositionButton = (props: ClonePositionButtonProps) => {
  const { onClonePosition, disabled } = props;

  const { selectedPositionIds } = useSelectedPositionState();
  if (!(selectedPositionIds.length > 0)) return null;

  return (
    <IconButton
      disabled={disabled}
      color="primary"
      onClick={() => onClonePosition(selectedPositionIds)}
    >
      <ContentCopyIcon />
    </IconButton>
  );
};
